<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-3">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Recuperar contraseña</h1>
              <!--<p class="text-lead text-white">Use these awesome forms to login or create new account in your project for free.</p>-->
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="card bg-secondary border-0">
            
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Completa el siguiente formulario:</small>
              </div>
              <form role="form" @submit.prevent="sendForm">

                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-email-83"
                            placeholder="Ingresa tu email"
                            name="Email"
                            :error="getError('Email')"
                            v-validate="'required|email'"
                            v-model="model.email">
                </base-input>
                <!--
                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-hat-3"
                            placeholder="Ingresa tu sponsor"
                            name="sponsor"
                            :error="getError('sponsor')"
                            v-validate="'required'"
                            v-model="model.sponsor">
                </base-input>
                -->
                
                <div class="text-center">
                  <button :disabled="delivered" type="submit" class="btn btn-primary mt-4">Enviar Recuperación</button>
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/login" class="text-light"><small>Volver al ingreso</small></router-link>
            </div>
            <div class="col-6 text-right">
              <!--<router-link to="/register" class="text-light"><small>Create new account</small></router-link>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'register',
  data() {
    return {
      model: {
        email: '',
        sponsor: ''
      },
      delivered: false,
    }
  },
  methods: {
        sendForm()
        {
            var vm = this;
            this.firstFormSubmit().then( response => {
                console.log('retorno promesa de validacion', response);
                if( response ){
                    vm.axios({
                        url: 'password/email',
                        method: 'POST',
                        data: {
                            email: vm.model.email,
                            //sponsor: vm.model.sponsor,
                        }
                    }).then( response => {
                        vm.$notify({
                            type: 'success',
                            message: response.data
                        });
                        vm.delivered = true;
                    }).catch( error => {
                        console.log( Object.keys(error.response) );
                        if( error.response.status == 422 ){
                            Object.keys(error.response.data.errors).forEach( clave => {
                                vm.$notify({
                                    type: 'warning',
                                    message: error.response.data.errors[clave][0]
                                })
                            });
                        }else{
                            vm.$notify({
                                type: 'default',
                                message: 'Hubo un error, favor comunicarse con soporte técnico'
                            })
                        }
                    });
                }
            });
        },
        async firstFormSubmit() {
            try {
                return await this.$validator.validateAll();
            } catch {
                return false;
            }
            finally {
                this.validated = true;
            }
        },
        getError(name){
            return this.errors.first(name)
        },
        isValid(name) {
            return this.validated && !this.errors.has(name);
        },
  }
};
</script>
<style lang="scss">
    .invalid-feedback {
        text-align: center;
    }
</style>
